import { useState } from "react";
import TemporaryDrawer from "../ui/temp-drawer.component";
import LeagueRequirements from "./league-requirements.component";
import { LeagueType, LeagueName } from "./league.component";
import { LeaguePlayerStatus } from "./rank-status.component";

interface LeagueTitleProps {
  league: LeagueType,
  status: LeaguePlayerStatus,
  leagueRank: number
}

const LeagueTitle: React.FC<LeagueTitleProps> = ({league, status, leagueRank}) => {

  const [showDrawer, setShowDrawer] = useState(false);

  return (

    <>

      <button
        className="flat-card flex center gap-2 my-4 relative"
        onClick={(e) => {
          setShowDrawer(true);
          e.stopPropagation();
        }}
      >

        {/* Badge on qualification in progress (status:2) */}
        { status !== LeaguePlayerStatus.QUALIFIED &&
          <div className="absolute -top-1 -right-1">
            <span className="relative flex h-3 w-3">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-yellow-100 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-yellow-100"></span>
            </span>
          </div>
        }

        <img width={25} height={25} src={process.env.REACT_APP_STATIC_ASSETS + "/images/" + LeagueName[league] + "-step.png"}/>

        <p className="font-BioRhyme capitalize"> {LeagueName[league]} League</p>

      </button>

      <TemporaryDrawer
        title={`Qualification rules`}
        closeWhenClickingOutside={true}
        anchor={'bottom'}
        size={'auto'}
        open={showDrawer}
        lineIcon={false}
        onClose={() => {
          setShowDrawer(false);
      }}>

        <LeagueRequirements league={league} leagueRank={leagueRank}/>

      </TemporaryDrawer>

    </>

   );
}

export default LeagueTitle;